// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"a0bd0408","619":"bbded521","741":"5005411d","750":"04b2eb4d","841":"a0bd0408","876":"a0bd0408"}[chunkId] + ".chunk.css";
};